import "./assets/css/legal-documents.css";
import React, { Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "font-awesome/css/font-awesome.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/style.css";
import "./assets/css/sel_style.css";
import "./assets/css/responsive.css";
import "./assets/css/checkout.css";
import "./assets/css/myStyle.css";
import "./assets/css/mobile-shell.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MobileAppShell from "./components/layout/MobileAppShell";
import InterfaceModeBoot from "./components/layout/InterfaceModeBoot";
import PwaInstallPrompt from "./components/layout/PwaInstallPrompt";
import Home from "./containers/user/Home";
import ProductListing from "./containers/user/ProductListing";
import ProductDetail from "./containers/user/ProductDetail";
import ServicesDisplay from "./containers/user/service/ServicesDisplay";
import ServicesListing from "./containers/user/ServicesListing";
import ServiceDetail from "./containers/user/service/ServiceDetails";
import MyOrders from "./containers/user/MyOrders";
import MyCart from "./containers/user/MyCart";
import CheckOut from '../src/containers/user/productCheckout/checkOut';
import CheckOutCompletePage from "./containers/user/productCheckout/checkoutComplete";
import MyWishlist from "./containers/user/MyWishlist";
import SaveLaterlist from "./containers/user/SaveLaterlist";
import MyProfile from "./containers/user/MyProfile";
import OrderDetail from "./containers/user/OrderDetail";
import MyPayments from "./containers/user/MyPayments";
import UserContact from "./containers/user/Contact";
import MyBanner from "./containers/user/MyBanners";
import CreateNewBanner from "./containers/user/CreateBanner";
import MyBannerEdit from "./containers/user/MyBannerEdit";
import PrivacyPolicy from "./containers/user/PrivacyPolicy";
import TermsOfService from "./containers/user/TermsOfService";

import Notifications from "./containers/user/Notifications";
import Chat from "./containers/user/Chat";
import MyCoupons from "./containers/user/MyCoupons";
import OrderSummary from "./containers/user/OrderSummary";
import PrivateRoute from "./components/common/PrivateRoute";
import PublicRoute from "./components/common/PublicRoute";
import PageNotFound from "./components/common/PageNotFound";
import Role from "./helpers/role";
import { useSelector } from "react-redux";
import SpinnerLoader from "./components/common/SpinnerLoader";
import {
  ManageDeals,
  SellerLogin,
  SellerRegister,
  SellerResetPwd,
  SellerForgotPwd,
  ProductStockManagement,
  SellerChat,
  ServiceStockManagement,
  AddProduct,
  AddService,
  SellerDashboard,
  ProductOrders,
  ServiceOrders,
  ListedProducts,
  Contact,
  Payments,
  SellerProductDetail,
  SellerServiceDetail,
  SellerOrderDetail,
  SellerManageBannerAdvertisement,
  SellerBannerList,
  SellerBannerEdit,
  SellerManageSubscription,
  SellerCommunity,
  EditService,
  ServiceCheckoutStripe,
  EditProduct,
  SellerNotifications,
  SellerProfile,
  SellerSharePostData,
  SupportSeller,
  SupportSellerEmail,
  SupportSellerCall,
  SellerMyProfile,
  SupportTicketSeller,
  SupportTicketChat,
  SellerStripeOnboarding,
  SellerTaxSettings,
  SellerProjectsList,
  SellerProjectDetails,
  QuoteManagement,
  SellerEarnings,
  SellerWithdrawal,
  SellerLicenses,
  SellerTeamManagement,
} from "./lazy/sellerLazy";

import CorporateTeamManagement from "./containers/user/CorporateTeamManagement";
import AcceptInvitation from "./containers/user/AcceptInvitation";
import UserResetPwd from './containers/user/ResetPassword';
import ManagePaymentDetails from './containers/admin/ManagePaymentDetails';
import AdvertiseShare from "./components/common/AdvertiseShare";
import AdminLogin from "./containers/admin/Login";
import AdminRegister from "./containers/admin/Register";
import AdminForgotPwd from "./containers/admin/ForgotPassword";
import AdminResetPwd from "./containers/admin/ResetPassword";
import AdminProductOrders from "./containers/admin/AdminProductOrders";
import AdminServiceOrders from "./containers/admin/AdminServiceOrders";
import AdminDashboard from "./containers/admin/Dashboard";
import AdminPayments from "./containers/admin/Payments";
import AdminChat from "./containers/admin/Chat";
import ManageCommunityPost from "./containers/admin/ManageCommunityPost";

import AdminPostModule from "./containers/admin/PostModule";
import AdminPostModuleAddNew from "./containers/admin/PostModuleAddNew";
import AdminPostEdit from "./containers/admin/PostModelEdit";

import AdminPageModule from "./containers/admin/PageModule";
import AdminPageModuleAddNew from "./containers/admin/PageModuleAddNew";
import AdminPageEdit from "./containers/admin/PageModelEdit";

import AdminCategoryModel from "./containers/admin/CategoryModule";
import AdminCategoryModelEdit from "./containers/admin/CategoryModuleEdit";
import AdminDisputesDashboard from "./containers/admin/AdminDisputesDashboard";
import AdminCMSInterface from "./containers/admin/AdminCMSInterface";

import ManageOrderDetails from "./containers/admin/ManageOrderDetails";
import ManageProducts from "./containers/admin/ManageProducts";
import ManageProductDetails from "./containers/admin/ManageProductDetails";
import ManageServices from "./containers/admin/ManageServices";
import ManageServiceDetails from "./containers/admin/ManageServiceDetails";
import ManageNotifications from "./containers/admin/ManageNotifications";
import ContactFromUser from "./containers/admin/ContactFromUser";
import ManageCustomers from "./containers/admin/ManageCustomers";
import ManageCommunity from "./containers/admin/ManageCommunity";
import ManageReports from "./containers/admin/ManageReports";
import ManageReportsServices from "./containers/admin/ManageReportsServices";
import ManageBannerAdvertisement from "./containers/admin/ManageBannerAdvertisement";
import ManageBannerList from "./containers/admin/ManageBannerList";
import ManageBannerListEdit from "./containers/admin/ManageBannerListEdit";

import ManageProductsCategory from "../src/containers/admin/ManageProductsCategory";
import ManageServiceCategory from "../src/containers/admin/ManageServiceCategory";
import PlatformFeeSettings from "../src/containers/admin/ManageFlatFee";
import ManageStripePayout from "../src/containers/admin/ManageStripePayout";
import ManageBrands from "./containers/admin/ManageBrands";
import AdminSellerEarnings from "./containers/admin/ViewSellerEarnings"
import AdminLicenses from "./containers/admin/AdminLicenses";

import AdminManageSubPlan from "./containers/admin/ManageSubscriptionPlan";

import AdminEditService from "./containers/admin/EditService";

import Support from "./containers/admin/SupportAdmin";

import AddCoupon from "./containers/admin/AddCoupon";
import CouponsListing from "./containers/admin/CouponsListing";
import ManageVendors from "./containers/admin/ManageVendors";
import VandorRegister from "./containers/admin/VandorRegister";
import UserRegister from "./containers/admin/UserRegister";
import Community from "./containers/community/Community";
import CommunityProfile from "./containers/community/CommunityProfile";
import SharePostData from "./components/community/common/SharePostData";
import AdminSharePostData from "./components/community/common/AdminSharePostData";

import Blog from "./components/common/BlogModel";
import BlogDetail from "./components/common/BlogDetails";
import PageModel from "./components/common/PageModel";
import PageDetail from "./components/common/PageDetails";

import Zoom from "./components/user/common/services/zoom/Zoom";
import ScrollToTopButton from "./containers/user/ScrollToTopButton";
// import BannerCheckOut from './containers/user/BannerCheckOut';
import StripePaymentForm from "./containers/user/paymentCheckoutStripe";
import { BannerStripePaymentForm } from "./containers/user/paymentCheckoutStripe";
import ServiceOrder from "./containers/user/service/ServiceOrder";
import adminAddService from './containers/admin/AddService';
import AdminProfile from "./containers/community/AdminProfile";
import SupportUser from "./containers/user/SupportUser";
import SupportUserEmail from "./containers/user/SupportUserEmail";
import { SupportUserCall } from "./containers/user/SupportUserCall";
import { SupportAdminCall } from "./containers/admin/SupportAdminCall";
import SupportAdmin from "./containers/admin/SupportAdmin";
import AdminMyProfile from "./containers/admin/AdminMyProfile";
import ManageAdmins from "./containers/admin/ManageAdmins";
import AddAdmin from "./containers/admin/AddAdmin"
import AccessPermission from "./containers/admin/AccessPermission";
import ManageCapability from "./containers/admin/ManageCapability";
import EditCoupon from "./containers/admin/EditCoupon";



import DealListedItems from "./components/user/home/DealListedItems";
import AdminManageDeals from "./containers/admin/ManageDeals"
import ServiceMilestoneCheckout from "./containers/user/milestone/ServiceMilestoneCheckout";
import BuyerProjectsList from "./containers/user/BuyerProjectsList";
import TiledeskWidget from "./components/chatbot/TiledeskWidget";
import Chatbot from "./components/chatbot/Chatbot";
import MyQuotes from "./containers/user/MyQuotes";
import ManageCurrencies from "./containers/admin/ManageCurrencies";

import LegalDocumentsDashboard from "./containers/admin/legal-documents/legal-documents-dashboard";
import CreateLegalDocument from "./containers/admin/legal-documents/create-legal-document";
import EditLegalDocument from "./containers/admin/legal-documents/edit-legal-document";
import ViewLegalDocument from "./containers/admin/legal-documents/view-legal-document";
import AgreementManagement from "./containers/admin/legal-documents/agreement-management";
import DocumentVersions from "./containers/admin/legal-documents/document-versions"

function App() {
  const userInfo = useSelector((state) => state.auth.userInfo);

  return (
    <div className="App">
      {/* <TiledeskWidget projectId="685416d86dc4f60013952075" /> */}
      <Chatbot />
      <Router>
        <InterfaceModeBoot />
        <PwaInstallPrompt />
        <MobileAppShell>
        <ScrollToTopButton />
        <Suspense fallback={<SpinnerLoader />}>
        <Switch>
          <PublicRoute
            path="/"
            restricted={false}
            component={Home}
            exact
          />

          <PublicRoute
            path="/user/reset-password"
            restricted={false}
            component={UserResetPwd}
            exact
          />

          <PublicRoute
            path="/product-listing"
            restricted={false}
            component={ProductListing}
            exact
          />

          <PublicRoute
            path="/product-detail/:id"
            restricted={false}
            component={ProductDetail}
            exact
          />


          <PublicRoute
            path="/service-display"
            restricted={false}
            component={ServicesDisplay}
            exact
          />

          {/* <PublicRoute
            path="/service-listing"
            restricted={false}
            component={ServiceListing}
            exact
          /> */}

          {/* Public Legal Pages */}
          <PublicRoute
            path="/privacy-policy"
            restricted={false}
            component={PrivacyPolicy}
            exact
          />

          <PublicRoute
            path="/terms-of-service"
            restricted={false}
            component={TermsOfService}
            exact
          />

          <PublicRoute
            path="/accept-invite"
            restricted={false}
            component={AcceptInvitation}
          />

          {/* Legal Documents Dashboard */}
          <PrivateRoute
            path="/admin/legal-documents"
            component={LegalDocumentsDashboard}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Create Legal Document */}
          <PrivateRoute
            path="/admin/legal-documents/create"
            component={CreateLegalDocument}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Edit Legal Document */}
          <PrivateRoute
            path="/admin/legal-documents/edit/:documentId"
            component={EditLegalDocument}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* View Legal Document */}
          <PrivateRoute
            path="/admin/legal-documents/view/:documentId"
            component={ViewLegalDocument}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Agreement Management */}
          <PrivateRoute
            path="/admin/legal-agreements"
            component={AgreementManagement}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/legal-documents/versions/:documentId"
            component={DocumentVersions}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Document Versions (if you want to add this later) */}
          {/* <PrivateRoute
            path="/admin/legal-documents/versions/:documentId"
            component={DocumentVersions}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          /> */}

          {/* Agreement Details (if you want to add this later) */}
          {/* <PrivateRoute
            path="/admin/legal-documents/agreements/:agreementId"
            component={AgreementDetails}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          /> */}

          {/* Compliance Reports (if you want to add this later) */}
          {/* <PrivateRoute
            path="/admin/compliance-reports"
            component={ComplianceReports}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          /> */}

          <PublicRoute
            path="/service-listing"
            restricted={false}
            component={ServicesListing}
            exact
          />

          <PublicRoute
            path="/service-detail/:id"
            restricted={false}
            component={ServiceDetail}
            exact
          />

          <PublicRoute
            path="/my-cart"
            restricted={false}
            component={MyCart}
            exact
          />

          {/* Product orderCheckout */}
          <PrivateRoute
            path="/orderCheckout"
            restricted={false}
            component={CheckOut}
            exact
          />

          <PrivateRoute
            path="/checkOutCompletePage"
            restricted={false}
            component={CheckOutCompletePage}
            exact
          />

          <PrivateRoute
            path="/notifications"
            restricted={false}
            component={Notifications}
            exact
          />

          <PrivateRoute
            path="/chat"
            restricted={false}
            component={Chat}
            exact
          />

          <PublicRoute
            path="/user-contact"
            restricted={false}
            component={UserContact}
            exact
          />

          <PrivateRoute
            path="/user-support"
            restricted={false}
            component={SupportUser}
            exact
          />

          <PrivateRoute
            path="/user-support-email"
            restricted={false}
            component={SupportUserEmail}
            exact
          />

          <PrivateRoute
            path="/my-profile"
            component={MyProfile}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/corporate/team"
            component={CorporateTeamManagement}
            roles={[Role.user, Role.buyer_admin, Role.buyer_finance, Role.procurement]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/user/team"
            component={CorporateTeamManagement}
            roles={[Role.user, Role.buyer_admin, Role.buyer_finance, Role.procurement]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-coupons"
            component={MyCoupons}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-wishlist"
            component={MyWishlist}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/savelater"
            component={SaveLaterlist}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/service-order"
            component={ServiceOrder}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-orders"
            component={MyOrders}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-quotes"
            component={MyQuotes}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-contracts"
            component={BuyerProjectsList}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/checkout/milestones/:projectId"
            component={ServiceMilestoneCheckout}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-banners"
            component={MyBanner}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/create-banner"
            component={CreateNewBanner}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/bannerCheckout"
            restricted={false}
            component={BannerStripePaymentForm}
            exact
          />

          <PrivateRoute
            path="/service_Charge_Checkout"
            restricted={false}
            component={StripePaymentForm}
            exact
          />

          <PrivateRoute
            path="/user/edit-Advertisement/:id"
            component={MyBannerEdit}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact />

          <PrivateRoute
            path="/user/support-call"
            component={SupportUserCall}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact />

          <PrivateRoute
            path="/order-detail/:id"
            component={OrderDetail}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/my-payments"
            component={MyPayments}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/order-summary/:id"
            component={OrderSummary}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* ManageDeals */}

          <PrivateRoute
            path="/seller/manage-deals"
            component={ManageDeals}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Seller routes */}
          <PublicRoute
            path="/seller/login"
            restricted={false}
            component={SellerLogin}
            exact
          />

          <PublicRoute
            path="/seller/register"
            restricted={false}
            component={SellerRegister}
            exact
          />

          <PublicRoute
            path="/seller/reset-password"
            restricted={false}
            component={SellerResetPwd}
            exact
          />

          <PublicRoute
            path="/seller/forgot-password"
            restricted={false}
            component={SellerForgotPwd}
            exact
          />

          <PrivateRoute
            path="/seller/dashboard"
            component={SellerDashboard}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* SellerManageSubscription */}
          <PrivateRoute
            path="/seller/advertising-subscription"
            component={SellerManageSubscription}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/create-advertisement"
            component={SellerManageBannerAdvertisement}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/manage-advertisement"
            component={SellerBannerList}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/edit-Advertisement/:id"
            component={SellerBannerEdit}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/product-management"
            component={ProductStockManagement}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/quote-management"
            component={QuoteManagement}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/team"
            component={SellerTeamManagement}
            roles={[Role.seller, Role.seller_manager, Role.finance, Role.fulfillment, Role.support]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/notifications"
            component={SellerNotifications}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/license"
            component={SellerLicenses}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />


          <PrivateRoute
            path="/seller/chat"
            component={SellerChat}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/service-management"
            component={ServiceStockManagement}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/add-product"
            component={AddProduct}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/edit-product/:id"
            component={EditProduct}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/product-orders"
            component={ProductOrders}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/earnings"
            component={SellerEarnings}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/withdrawal"
            component={SellerWithdrawal}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/service-orders"
            component={ServiceOrders}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/listed-items"
            component={ListedProducts}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/contact"
            component={Contact}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/payments"
            component={Payments}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/product-detail/:id"
            component={SellerProductDetail}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/service-detail/:id"
            component={SellerServiceDetail}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/order-detail/:id"
            component={SellerOrderDetail}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/add-service"
            component={AddService}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/service-checkout"
            component={ServiceCheckoutStripe}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/edit-service/:id"
            component={EditService}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/support"
            component={SupportSeller}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/seller-support-email"
            component={SupportSellerEmail}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/support-call"
            component={SupportSellerCall}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/stripe-onboarding"
            component={SellerStripeOnboarding}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/tax-settings"
            component={SellerTaxSettings}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/projects"
            component={SellerProjectsList}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/seller/project/:id"
            component={SellerProjectDetails}
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Admin routes */}
          <PublicRoute
            path="/admin/login"
            restricted={false}
            component={AdminLogin}
            exact
          />

          <PublicRoute
            path="/admin/register"
            restricted={false}
            component={AdminRegister}
            exact
          />

          <PrivateRoute
            path="/admin/forgot-password"
            restricted={false}
            component={AdminForgotPwd}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PublicRoute
            path="/admin/reset-password"
            component={AdminResetPwd}
            exact
          />

          <PrivateRoute
            path="/admin/add-admin"
            restricted={false}
            component={AddAdmin}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/access-permission"
            restricted={false}
            component={AccessPermission}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/payments"
            restricted={false}
            component={AdminPayments}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-community-post"
            restricted={false}
            component={ManageCommunityPost}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-posts"
            restricted={false}
            component={AdminPostModule}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/create-post"
            restricted={false}
            component={AdminPostModuleAddNew}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/edit-post/:id"
            restricted={false}
            component={AdminPostEdit}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/page-module"
            restricted={false}
            component={AdminPageModule}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/page-module-add-new"
            restricted={false}
            component={AdminPageModuleAddNew}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/page-module-edit/:id"
            restricted={false}
            component={AdminPageEdit}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-blog-Categories"
            restricted={false}
            component={AdminCategoryModel}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/edit-blog-category/:id"
            restricted={false}
            component={AdminCategoryModelEdit}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-payment-details/:id"
            restricted={false}
            component={ManagePaymentDetails}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/chat"
            restricted={false}
            component={AdminChat}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-order-details/:id"
            restricted={false}
            component={ManageOrderDetails}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-products"
            restricted={false}
            component={ManageProducts}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/product-details/:id"
            restricted={false}
            component={ManageProductDetails}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-services"
            restricted={false}
            component={ManageServices}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-product-categories"
            restricted={false}
            component={ManageProductsCategory}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/seller-licenses"
            restricted={false}
            component={AdminLicenses}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/seller-earnings"
            restricted={false}
            component={AdminSellerEarnings}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-brands"
            restricted={false}
            component={ManageBrands}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-service-categories"
            restricted={false}
            component={ManageServiceCategory}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-flat-fee"
            restricted={false}
            component={PlatformFeeSettings}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/stripe-payout"
            restricted={false}
            component={ManageStripePayout}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-currencies"
            restricted={false}
            component={ManageCurrencies}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-service-details"
            restricted={false}
            component={ManageServiceDetails}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/community"
            component={ManageCommunity}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-admins"
            component={ManageAdmins}
            roles={[Role.super_admin]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/product-reports"
            component={ManageReports}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />


          <PrivateRoute
            path="/admin/service-reports"
            component={ManageReportsServices}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/notifications"
            restricted={false}
            component={ManageNotifications}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/buyers-contact"
            restricted={false}
            component={ContactFromUser}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-customers"
            restricted={false}
            component={ManageCustomers}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/product-orders"
            component={AdminProductOrders}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/service-orders"
            component={AdminServiceOrders}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/dashboard"
            component={AdminDashboard}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/disputes"
            component={AdminDisputesDashboard}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/cms"
            component={AdminCMSInterface}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/add-coupon"
            component={AddCoupon}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/edit-coupon"
            component={EditCoupon}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-coupons"
            component={CouponsListing}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-vendors"
            component={ManageVendors}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/add-vendor"
            component={VandorRegister}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/user_register"
            component={UserRegister}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* <PrivateRoute
            path="/admin/manage-community-post"
            component={ManageCommunityPost}
             roles={[Role.super_admin, Role.admin]}
            currentUserRole={userInfo.role}
            exact
          /> */}

          <PrivateRoute
            path="/admin/add-service"
            component={adminAddService}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />
          {/* Community Routes */}
          <PrivateRoute
            path="/admin/create-advertisement"
            component={ManageBannerAdvertisement}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-support"
            component={SupportAdmin}
            roles={[Role.super_admin, Role.admin, Role.manager, Role.law_body]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/support-call"
            component={SupportAdminCall}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-advertisement"
            component={ManageBannerList}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/edit-advertisement/:id"
            component={ManageBannerListEdit}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-subscription"
            component={AdminManageSubPlan}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/admin/manage-Capabilities"
            component={ManageCapability}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />


          <PrivateRoute path="/admin/edit-service/:id"
            component={AdminEditService}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          <PrivateRoute
            path="/community"
            restricted={false}
            component={Community}
            exact
          />

          <PrivateRoute
            path="/seller/community"
            restricted={false}
            component={SellerCommunity}
            exact
          />

          <PrivateRoute
            path="/community-profile"
            restricted={false}
            component={CommunityProfile}
            exact
          />

          <PrivateRoute
            path="/seller/account"
            restricted={false}
            component={SellerProfile}
            exact
          />
          {/* SharePostDatd */}

          {/* <PublicRoute
            path="/share_community/:id"
            restricted={false}
            component={SharePostDatd}
            exact
          /> */}

          <PublicRoute
            path="/share_community/:id"
            restricted={false}
            component={SharePostData}
            exact
          />

          <PublicRoute
            path="/seller_share_community/:id"
            restricted={false}
            component={SellerSharePostData}
            exact
          />

          <PrivateRoute
            path="/seller/support-tickets"
            restricted={false}
            component={SupportTicketSeller}
            exact
          />

          <PublicRoute
            path="/seller/support_ticket_message"
            restricted={false}
            component={SupportTicketChat}
            exact
          />

          <PublicRoute
            path="/admin_share_community/:id"
            restricted={false}
            component={AdminSharePostData}
            exact
          />

          <PrivateRoute
            path="/seller/myprofile"
            roles={[Role.seller]}
            currentUserRole={userInfo.role}
            component={SellerMyProfile}
            exact
          />

          <PublicRoute
            path="/admin/account"
            restricted={false}
            component={AdminProfile}
            exact
          />


          <PublicRoute
            path="/admin/my-profile"
            restricted={false}
            component={AdminMyProfile}
            exact
          />

          {/* Blog */}
          <PublicRoute
            path="/blog"
            restricted={false}
            component={Blog}
            exact
          />

          <PublicRoute
            path="/blog-detail/:slug"
            restricted={false}
            component={BlogDetail}
            exact
          />

          {/* Advertise Share */}
          <PublicRoute
            path="/advertisement/:slug"
            restricted={false}
            component={AdvertiseShare}
            exact
          />

          {/* PageDetail */}
          <PublicRoute
            path="/page"
            restricted={false}
            component={PageModel}
            exact
          />

          <PublicRoute
            path="/page/:slug"
            restricted={false}
            component={PageDetail}
            exact
          />

          <PrivateRoute
            path="/zoom-authentication"
            component={Zoom}
            roles={[Role.user]}
            currentUserRole={userInfo.role}
            exact
          />

          <PublicRoute
            path="/deal-ofthe-day"
            restricted={false}
            component={DealListedItems}
            exact
          />

          <PrivateRoute
            path="/admin/manage-deals"
            component={AdminManageDeals}
            roles={[Role.super_admin, Role.admin, Role.manager]}
            currentUserRole={userInfo.role}
            exact
          />

          {/* Not found */}
          <Route component={PageNotFound} />
        </Switch>
        </Suspense>
        </MobileAppShell>
      </Router>
    </div>
  );
}

export default App;
